import Endpoint from "@/utils/endPoint";
const albumTempListEndpoint = new Endpoint("/albums/templates/teachers/");
const albumListEndpoint = new Endpoint("/albums/teachers/");
const albumEndpoint = new Endpoint("/albums/teachers/{albumId}");
const albumBodyEndpoint = new Endpoint("/albums/teachers/{albumId}/body");
const albumBodyPageEndpoint = new Endpoint("/albums/teachers/{albumId}/body/pages");
const albumStatusEndpoint = new Endpoint("/albums/teachers/{albumId}/status/{status}");

const albumDigitalEndpoint = new Endpoint("/albums/teachers/{albumId}/digital_copy/read_for_generate");

class AlbumService {
    async getAlbumTempListService(params) {
        const result = await albumTempListEndpoint.get(params);
        return result;
    }

    async getAlbumListService(params) {
        const result = await albumListEndpoint.get(params);
        return result;
    }

    async createAlbumService(params) {
        const result = await albumListEndpoint.post(params);
        return result;
    }

    async getAlbumService(params) {
        const result = await albumEndpoint.get(params);
        return result;
    }

    async updateAlbumService(params) {
        const { albumId, ...param } = params;
        const result = await albumEndpoint.put(param, { albumId });
        return result;
    }

    async delAlbumService(params) {
        const result = await albumEndpoint.del(null, params);
        return result;
    }

    async getAlbumBodyService(params) {
        const result = await albumBodyEndpoint.get(params);
        return result;
    }

    async updateAlbumBodyService(params) {
        const { albumId, albumBody } = params;
        const result = await albumBodyEndpoint.put(albumBody, { albumId });
        return result;
    }

    async updateAlbumBodyPageService(params) {
        const { albumId, ...param } = params;
        const result = await albumBodyPageEndpoint.put(param, { albumId });
        return result;
    }

    async updateAlbumStatusService(params) {
        const { status = "FINALIZED", albumId, ...param } = params;
        const result = await albumStatusEndpoint.put(param, { albumId, status });
        return result;
    }

    async createAlbumDigitalService(params) {
        const { albumId, ...param } = params;
        const result = await albumDigitalEndpoint.postWithParams({ ...param, album_id: albumId }, { albumId });
        return result;
    }
}

export default new AlbumService();
